export default __webpack_public_path__ + "static/media/clipboard-out.fc9a7305.svg";